const typography = {
  fontFamily: ["Outfit", "sans-serif"].join(","),
  fontSize: 13,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  h1: {
    fontSize: "3rem",
    fontWeight: 700,
    lineHeight: 1.25,
    letterSpacing: "0.5px",
  },
  h2: {
    fontSize: "1.75rem",
    fontWeight: 600,
    lineHeight: 1.25,
    letterSpacing: "0.5px",
  },
  h3: {
    fontSize: "1.5rem",
    fontWeight: 600,
    lineHeight: 1.25,
    letterSpacing: "0.5px",
  },
  h4: {
    fontSize: "1.125rem",
    fontWeight: 500,
    lineHeight: 1.25,
    letterSpacing: "0.5px",
  },
  h5: {
    fontSize: "1.0625rem",
    fontWeight: 500,
    lineHeight: 1.25,
    letterSpacing: "0.5px",
  },
  h6: {
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: 1.25,
    letterSpacing: "0.5px",
  },
  body1: {
    fontSize: 13,
    letterSpacing: "0.5px",
  },
  button: {
    textTransform: "none",
  },
};

export default typography;
